// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck.ck-icon{\n  vertical-align:middle\n}\n\n:root{\n  --ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))\n}\n\n.ck.ck-icon{\n  width:var(--ck-icon-size);\n  height:var(--ck-icon-size);\n  font-size:.8333350694em;\n  will-change:transform\n}\n\n.ck.ck-icon,.ck.ck-icon *{\n  color:inherit\n}\n\n[dir] .ck.ck-icon, [dir] .ck.ck-icon *{\n  cursor:inherit\n}\n\n.ck.ck-icon :not([fill]){\n  fill:currentColor\n}", ""]);
// Exports
module.exports = exports;
